import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import {setGetGroups} from '../../store/thunk/setGetGroups';
import {useFormik, FormikContext} from "formik";
import {setPostUpdateJackpot} from '../../store/thunk/setPostUpdateJackpot';
import {setGetGroupJackpot} from '../../store/thunk/setGetGroupJackpot';
import Dialog from '@material-ui/core/Dialog';
import {useRouter} from '../../../../../@casino/useRouter';
import Title from '../../../../../@casino/ui/title';
import {setGetJackpotView} from '../../store/thunk/setGetJackpotView';
import {setPostUpdateGive} from '../../store/thunk/setPostUpdateGive';
import { setPostUpdateVisible } from '../../store/thunk/setPostUpdateVisible';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        margin: 0, 
        paddingTop: 0
    },
    wrapDialog: {
        width: 250, 
        height: 100, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleDialog: {
        textAlign: 'center'
    },
    errorTitleDialog: {
        fontWeight: 700,
        color: 'red',
    },
    dialogButton: {
        color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        fontWeight: 700,
        textAlign: 'center'
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%', 
    },
    select: {
        border: 0,
        background: '#293356',
        boxShadow: 'inset 0 1px 0 0 hsl(0deg 0% 100% / 20%)',
        paddingLeft: 8,
        borderRadius: '4px',
        color: '#fff',
        cursor: 'pointer',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'initial',
        height: '32px',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative',
        width: '420px'
    },
    save: {
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        marginRight: 12,
    },
    bgSave: {
        background: '#00a3f9',
        color: '#24263e',
        border: '1px solid #00a3f9',
    },
    bgCansel: {
        background: 'none',
        color: '#00a3f9',
        border: '1px solid #00a3f9',
    },
    bgOffBonus: {
        color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
    },
    wrapBlockButton: {
        width: '100%', 
        display: 'flex', 
        paddingBottom: 12
    },
    wrapSelect: {
        display: 'flex',
        marginBottom: 8
    },
    mr12: {
        marginRight: 12
    },
    divider: {
        height: 1, 
        width: '100%', 
        background: '#1c2542', 
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)'
    },
    titleJackpot: {
        fontSize: 16, 
        color: '#fff',
        fontFamily: 'PT-sans, sans-serif'
    },
    flex: {
        display: 'flex',
    }
}))

const JackpotEdit = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [openModalSuccess, setOpenModalSuccess] = React.useState(false);
    const [openModalError, setOpenModalError] = React.useState(false);
    const router = useRouter();
    const id = router.match.params.id;

    React.useEffect(() => {
        dispatch(setGetGroups({
            group: '',
            hide: false
        }));
        dispatch(setGetGroupJackpot({group: 'all'}))
        dispatch(setGetJackpotView({
            id
        }))
    }, [id]);

    const initialValues = useSelector(state => state.jackpot.view_jackpot);

    const onSubmit = (store) => {
        let rand = store.min_win - 0.5 + Math.random() * (store.max_win - store.min_win + 1);
        store.random = Math.round(rand);
        dispatch(setPostUpdateJackpot(store, setOpenModalSuccess, setOpenModalError))
    }

    const groups = useSelector(state => state.jackpot.list_group);
    const enableReinitialize = true;
    const formik = useFormik({onSubmit, initialValues, enableReinitialize});

    const group_jackpot = useSelector(state => state.jackpot.list_group_jackpot);

    const getJackpot = (item) => {
        switch (item) {
            case "platinum": return "Платиновый";
            case "gold": return "Золотой";
            case "silver": return "Серебряный";
            case "bronze": return "Бронзовый";
            default: return ''
        }
    }

    const getValidation = (val) => {
        if (!!!val.primary_storage || !!!val.secondary_storage || !!!val.min_win || !!!val.max_win || !!!val.min_bet || !!!val.max_bet || !!!val.name || val.groups === '0' || val.jackpot === '0') {
            return false;
        }

        return true
    }

    return (
        <div className={classes.root}>
            <Title label="Редактирование Джекпота" />
            <div>
            <FormikContext.Provider value={formik}>
                <form 
                    onSubmit={formik.handleSubmit}
                >
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <label htmlFor="name" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                        <span className={classes.helper}>Название джекпота</span>
                            <input 
                                type="text" 
                                name="name" 
                                id="name" 
                                onChange={(v) => formik.setFieldValue('name', v.target.value)}
                                value={formik.values.name}
                                className={classes.text}
                                style={{marginRight: 20}}
                            />
                    </label>

                    <span 
                        style={{padding: '5px 20px', height: 30, background: '#ffc324', display: 'flex', alignItems: 'center', borderRadius: 4, cursor: 'pointer', marginRight: 12}}
                        onClick={() => {
                            dispatch(setPostUpdateGive({
                                id: formik.values.id,
                                give: !formik.values.give
                            }));
                            formik.setFieldValue('give', !formik.values.give)
                        }}
                        >
                        {formik.values.give ? 'Отключить выдачу' : 'Возобновить выдачу'}
                    </span>
                    <span 
                        style={{padding: '5px 20px', height: 30, background: '#ffc324', display: 'flex', alignItems: 'center', borderRadius: 4, cursor: 'pointer'}}
                        onClick={() => {
                            dispatch(setPostUpdateVisible({
                                id: formik.values.id,
                                visible: !formik.values.visible
                            }));
                            formik.setFieldValue('visible', !formik.values.give)
                        }}
                        >
                        {formik.values.visible ? 'Отключить показ' : 'Возобновить показ'}
                    </span>
                </div>
                
                <div className={classes.wrapSelect}>
                    <select 
                        id="groups" 
                        name="groups" 
                        className={clsx(classes.select, classes.mr12)}
                        
                        value={formik.values.groups}
                        onChange={(v) => {
                            formik.setFieldValue('groups', v.target.value);
                            dispatch(setGetGroupJackpot({group: v.target.value}));
                        }}
                    >
                        <option value="all">Все</option>
                        {
                            groups.map((item) => <option value={item.groups}>{item.groups}</option>)
                        }
                        
                    </select>
                    <select 
                        id="jackpot" 
                        name="jackpot" 
                        className={classes.select}
                        value={formik.values.jackpot}
                        onChange={(v) => {
                            formik.setFieldValue('jackpot', v.target.value)
                            
                        }}
                    >
                        {
                            group_jackpot.map(item => <option value={item}>{getJackpot(item)}</option>)
                        }
                        
                    </select>
                </div>
                <div className={classes.divider}></div>
                <div>
                    <h3 className={classes.titleJackpot}>Первичный джекпот</h3>
                    <div>
                        <div style={{display: 'flex', columnGap: 12}}>
                            <label htmlFor="primary_storage" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Первичное накопление</span>
                                    <input 
                                        type="number" 
                                        name="primary_storage" 
                                        id="primary_storage" 
                                        className={classes.text}
                                        value={formik.values.primary_storage}
                                        onChange={(v) => formik.setFieldValue('primary_storage', v.target.value)}
                                    />
                            </label>
                            <label htmlFor="primary_storage" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Валюта</span>
                                <select 
                                    value={formik.values.currency} 
                                    onChange={(v) => formik.setFieldValue('currency', v.target.value)}
                                    style={{
                                        height: 34,
                                        borderRadius: 4,
                                        outline: 'none',
                                        background: '#1c2542',
                                        color: '#fff',
                                        paddingLeft: 12,
                                        border: 'none'
                                    }}
                                >
                                    <option value="" style={{display: 'none'}}>Выбрать валюту</option>
                                    <option value="RUB">RUB</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                    <option value="GEL">GEL</option>
                                    <option value="TRY">TRY</option>
                                </select>
                            </label>
                        </div>
                        <div className={classes.flex}>
                            <label htmlFor="min_win" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mr12)}>
                                <span className={classes.helper}>Мин. сумма выигрыша</span>
                                    <input 
                                        type="number" 
                                        name="min_win" 
                                        id="min_win" 
                                        value={formik.values.min_win}
                                        onChange={(v) => formik.setFieldValue('min_win', v.target.value)}
                                        className={classes.text}
                                    />
                            </label>
                            <label htmlFor="max_win" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Макс. сумма выигрыша</span>
                                    <input 
                                        type="number" 
                                        name="max_win" 
                                        id="max_win" 
                                        value={formik.values.max_win}
                                        onChange={(v) => formik.setFieldValue('max_win', v.target.value)}
                                        className={classes.text}
                                    />
                            </label>
                        </div>
                        <div className={classes.flex}>
                            <label htmlFor="min_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mr12)}>
                                <span className={classes.helper}>Мин. ставка</span>
                                    <input 
                                        type="number" 
                                        name="min_bet" 
                                        id="min_bet" 
                                        value={formik.values.min_bet}
                                        onChange={(v) => formik.setFieldValue('min_bet', v.target.value)}
                                        className={classes.text}
                                    />
                            </label>
                            <label htmlFor="max_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Макс. ставка</span>
                                    <input 
                                        type="number" 
                                        name="max_bet" 
                                        id="max_bet"
                                        value={formik.values.max_bet}
                                        onChange={(v) => formik.setFieldValue('max_bet', v.target.value)}
                                        className={classes.text}
                                    />
                            </label>
                        </div>
                    </div>
                </div>
                <div className={classes.divider}></div>
                <div>
                    <h3 className={classes.titleJackpot}>Вторичный джекпот</h3>
                    <div>
                        <label htmlFor="secondary_storage" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Вторичное накопление</span>
                                <input 
                                    type="number" 
                                    name="secondary_storage" 
                                    id="secondary_storage"
                                    value={formik.values.secondary_storage}
                                    onChange={(v) => formik.setFieldValue('secondary_storage', v.target.value)} 
                                    className={classes.text}
                                />
                        </label>
                    </div>
                </div>
                <div>
                <span   
                    className={clsx(classes.save, getValidation(formik.values) ? classes.bgSave : classes.bgCansel)}
                    style={{cursor: getValidation(formik.values) ? classes.bgSave : classes.bgCansel}}   
                    onClick={() => {
                        if (getValidation(formik.values)) {
                            formik.submitForm()
                        }
                    }}
                >
                    Сохранить
                </span>
                <span 
                    className={clsx(classes.save, classes.bgCansel)}
                    onClick={() => router.history.push('/jackpot')}
                >
                    Отмена
                </span>
                </div>
                </form>
            </FormikContext.Provider>    
            </div>
            <Dialog onClose={() => setOpenModalSuccess(false)} open={openModalSuccess}>
                <div className={classes.wrapDialog}>
                    <h3 className={classes.titleDialog}>Джекпот сохранен</h3>
                    <span className={classes.dialogButton}
                        onClick={() => {
                            setOpenModalSuccess(false)
                            router.history.push('/jackpot');
                        }}
                    >
                        ОК
                    </span>
                </div>
            </Dialog>
            <Dialog onClose={() => setOpenModalError(false)} open={openModalError}>
            <div className={classes.wrapDialog}>
                <h3 className={classes.titleDialog}>
                    <span className={classes.errorTitleDialog}>
                        ОШИБКА!
                    </span> 
                    Бонус не сохранен
                </h3>
                <span 
                    className={classes.dialogButton}
                    onClick={() => {
                        setOpenModalError(false);
                        router.history.push('/jackpot');
                    }}
                    >
                    ОК
                </span>
            </div>
        </Dialog>
        </div>
    )
}

export default JackpotEdit